import { createExporter } from "utils/createExporter";
import { administrationRequests } from "api/administrationApi";
import { candidateRequests } from "api/candidateApi";

export const CandidatesExporter = createExporter(
  "candidates.xlsx",
  [
    { key: "id", label: "ID" },
    { key: "number", label: "Вх. номер" },
    { key: "firstName", label: "име" },
    { key: "secondName", label: "презиме" },
    { key: "lastName", label: "фамилия" },
    { key: "firstPrioritySpeciality", label: "1-во желание" },
    { key: "createdOnFormatted", label: "дата на кандидатурата" },
    { key: "status", label: "статус" },
    { key: "workerNames", label: "обработва се от" },
  ],
  record => ({
    ...record,
    status: record.status?.displayTextBg,
    firstPrioritySpeciality: record.firstPrioritySpeciality?.name,
  }),
  [
    {
      source: "stateId",
      target: candidateRequests.getCandidacieStatesSelect(),
      name: "status",
    },
    {
      source: "firstPrioritySpecialityId",
      target: administrationRequests.getSpecialitiesSelect(),
      name: "firstPrioritySpeciality",
    },
  ],
);
